// extracted by mini-css-extract-plugin
export default {"columnsContainer":"columnsContainer__2BhOY","cellSummary":"cellSummary__1afl_","orderSummaryHeader":"orderSummaryHeader__3n4ux","orderSummaryHeaderTitle":"orderSummaryHeaderTitle__3uI-P","orderSummaryHeaderSubtitle":"orderSummaryHeaderSubtitle__1Kq_L","bookingsList":"bookingsList__1W85i","cellBasket":"cellBasket__1wJPM","newOrderButton":"newOrderButton__3fsmX"};
    if(module.hot) {
      // 1788784362146
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  